export var AppNames = /*#__PURE__*/function (AppNames) {
  AppNames["EMBEDDABLE_DIRECTORY"] = "embeddableDirectory";
  AppNames["STANDALONE_DIRECTORY"] = "standaloneDirectory";
  return AppNames;
}({});
export function getAppName() {
  // @ts-ignore
  return window.__app_name__ || AppNames.EMBEDDABLE_DIRECTORY;
}